import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalOverlay = _resolveComponent("ModalOverlay")!
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_ModalOverlay, {
          key: 0,
          onClick: _ctx.closeModal
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "custom-modal",
          style: _normalizeStyle({ width: _ctx.width })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ModalHeader, {
              title: _ctx.title,
              onClose: _ctx.closeModal
            }, null, 8, ["title", "onClose"]),
            _createVNode(_component_ModalBody, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _: 3
            }),
            _createVNode(_component_ModalFooter, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ]),
              _: 3
            })
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}